import React, { PropsWithChildren } from "react";
import { Provider } from "context/List";

type ListData<T> = Array<T> & {
    pager: {
        total: number;
        total_page: number;
        last_page: number;
        per_page: number;
        current_page: number;
        order?: string;
        direction?: string;
        custom?: HashMap<number | undefined>;
    };
    active_filters: HashMap<unknown>;
};

interface Props {
    dataFetcher: (params?: HashMap<unknown>) => Promise<ListData<unknown>>;
    defaultFetcherParams?: HashMap<unknown>;
    cacheKey?: string;
    wordingPagerTotal?: string;
}

const ListProvider: React.FC<PropsWithChildren<Props>> = ({
    dataFetcher,
    defaultFetcherParams,
    cacheKey,
    wordingPagerTotal = "crud.pager.total.items",
    children,
}) => {
    return (
        <Provider
            cacheKey={cacheKey}
            dataFetcher={dataFetcher}
            defaultFetcherParams={defaultFetcherParams}
            wordingPagerTotal={wordingPagerTotal}
        >
            {children}
        </Provider>
    );
};

export default ListProvider;
